import { PermissionSetDefinitionsLight } from 'module/api/permission/types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PermissionAPI } from 'api/permission';

export const usePermissionSetDefinitionsLightQuery = (
  options?: Omit<
    UseQueryOptions<
      Array<PermissionSetDefinitionsLight>,
      unknown,
      Array<PermissionSetDefinitionsLight>,
      ['permission-set-definitions-light']
    >,
    'queryKey'
  >,
) => {
  return useQuery({
    queryKey: ['permission-set-definitions-light'],
    queryFn: () => PermissionAPI.getPermissionSetDefinitionsLight(),
    ...options,
  });
};

export const useNativePermissionSetDefinitionsLightQuery = () => {
  return usePermissionSetDefinitionsLightQuery({
    select: (data) =>
      data.filter((item) => item.permissionSetSpecificTo === 'NATIVE'),
  });
};
